import { ListEventsResponse } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/aqora_service_pb';
import { SystemEventModel } from '~/pages/SystemAdmin/models/SystemEventModel';

export class SystemEventListModel {
  events: SystemEventModel[];

  constructor(listEventsResponse: ListEventsResponse) {
    this.events = listEventsResponse.events.map(
      (event, index) => new SystemEventModel(event, index),
    );
  }
}
